$shm_hitalama_map_pane $mol_view
	Map_page $shm_hitalama_map_page
	attr *
		^
		selecting <= selecting? false
	minimal_height 0
	minimal_width 0
	pointer_pos /
	real_pointer_pos /number
	tool_mode \
	tool_mode_active false
	to_real_pos* null
	auto /
		<= keydown_listener $shm_listener /
			\keydown
			<= keydown_handler null
		<= keyup_listener $shm_listener /
			\keyup
			<= keyup_handler null
		<= blur_listener $shm_listener /
			\blur
			<= blur_handler null
			<= window null
		<= visibilitychange_listener $shm_listener /
			\visibilitychange
			<= visibilitychange_handler null
		<= ctrl_pressed? false
		<= drag_mode_enabled? false
		<= shift_pressed? false
		<= viewport_shifting? false
		<= pointer_client_pos? /number
	dimensions_viewport $mol_vector_2d<$mol_vector_range<number>> /
		<= dimensions_viewport_x $mol_vector_range<number> /
			Infinity
			-Infinity
		<= dimensions_viewport_y $mol_vector_range<number> /
			Infinity
			-Infinity
	box_in_viewport? <= dimensions_viewport
	center_to_point* null
	touch_event_disabled false
	view_rect_ensured <= view_rect null
	plugins /
		^
		<= Camera_url $shm_hitalama_map_camera_url
			state_key <= camera_state_key \
			zoom_default <= camera_zoom_default 1
			shift_default <= camera_shift_default $mol_vector_2d<number> /
				100
				100
		<= Touch $shm_hitalama_map_touch
			Map_page <= Map_page
			tool_active <= tool_mode_active
			tool_cancel <= tool_cancel
			zoom? <=> zoom? 1
			pan? <=> shift? $mol_vector_2d<number> /
				0
				0
			pointer_center => cursor_position
			allow_pan <= allow_pan true
			allow_draw false
			allow_zoom <= allow_touch_zoom true
			allow_wheel_zoom <= allow_zoom true
			action_type => action_type
			action_point => action_point
		<= Tool $shm_hitalama_map_pane_tool
			Map_page <= Map_page
			draft_cancel => tool_cancel
			mode <= tool_mode \
			client_pos_to_pane_pos* <= client_pos_to_pane_pos*
			to_real_pos* <= to_real_pos*
			zoom? <=> zoom?
			pan? <=> shift?
	sub /
		<= Drop $mol_drop
			Sub <= Back $shm_hitalama_map_back
				event_pointerdown? <=> back_event_pointerdown? null
				event_contextmenu? <=> back_event_contextmenu? null
			drop? <=> event_drop? null
		^ outside /
		<= Content $mol_view
			minimal_height 0
			minimal_width 0
			sub /
				<= Line_vert $mol_view
				<= Line_hor $mol_view
				^ body /
			style *
				transform <= transform \
		<= Tool
		^ selection_feedback_views /
			<= Selection_feedback $shm_hitalama_map_touch_selection
				point <= selection_feedback_point /number
				active <= selection_feedback_active false
				moving <= selection_feedback_moving false
		^ select_rect /
			<= Select_rect $mol_view
				style *
					left <= select_rect_left? \0px
					top <= select_rect_top? \0px
					width <= select_rect_width? \0px
					height <= select_rect_height? \0px
	select_rect_start_x? NaN
	select_rect_start_y? NaN
	select_rect_end_x? NaN
	select_rect_end_y? NaN
	select_rect_size /
	select_rect_pos /
	select_start? null
	select_finish null
	select_resize? null
	client_pos_to_pane_pos* null
	prevent_shift_x? false
	prevent_shift_y? false
	event *
		^
		pointermove? <=> pointer_move? null
		pointerdown? <=> pointer_down? null
		pointerup? <=> pointer_up? null
		contextmenu? <=> pane_contextmenu? null
		wheel? <=> wheel? null
	style *
		^
		cursor <= cursor_style \
